// @ts-check
import { useRouter } from 'next/router';
import React from 'react';
import ContentPage from "./ContentPage";
import { ContentPageContextProvider } from "@/src/cms/context/ContentPageContext";
import { css } from "emotion";

/**
 * @param {{
 *   sitepageid?: number | string;
 *   alias?: string | null;
 *   isLoading?: boolean;
 *   pagedata?: any;
 *   bodyStyle?: any;
 *   mutateBody?: (data: string) => string;
 *   renderBeforeContent?: () => import("react").ReactNode;
 *   renderOtherType?: boolean;
 *   bypassLogin?: boolean;
 *   bypassAuth?: boolean;
 *   children?: import("react").ReactNode;
 * }} props
 */
export default function ContentPageConnected(props) {
  const {
    sitepageid = null,
    pagedata,
    alias = null,
    bodyStyle = css``,
    mutateBody,
    renderBeforeContent = () => null,
    renderOtherType = false,
    bypassLogin = false,
    bypassAuth = false,
    children,
    isLoading,
  } = props;
  const router = useRouter();

  const _sitepageid = sitepageid || /** @type {string} */(router.query.slug);

  return (
    <ContentPageContextProvider
      sitepageid={_sitepageid}
      alias={alias}
      mutateBody={mutateBody}
      bypassLogin={bypassLogin}
      bypassAuth={bypassAuth}
      renderOtherType={renderOtherType}
      pagedata={pagedata}
      isLoading={isLoading}
    >
      <ContentPage 
        renderBeforeContent={renderBeforeContent}
        bodyStyle={bodyStyle}
      >
        {children}
      </ContentPage>
    </ContentPageContextProvider>
  )
};
